import React, { useEffect, useState, useContext } from 'react';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import { Context } from '../../../context/UserContext';
import Form from './Form';
import styles from '../../form/Form.module.css';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';

import * as VerificadoresAPI from '../../../api/verificadores';
import CRUDsAPI from '../../../api/CRUDs';

import { getEmpresaScope } from '../../../helpers/sessionEmpresa';

const CreateOrEdit = () => {
    const { empresaId, empresaIds } = getEmpresaScope();
    const [dados, setDados] = useState({
        empresaId: empresaId,
        ativo: true,
    });
    const [token] = useState(localStorage.getItem('token')) || '';
    const { parametro } = useContext(Context);
    const [ufs, setUfs] = useState([]);
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const urlParams = new URLSearchParams(window.location.search);

    const pathname = '/Municipio';
    const ul = urlParams.get('ul');
    const li = urlParams.get('li');
    const tipo = urlParams.get('tipo');
    const operacaoUUID = urlParams.get('operacao');
    const uuid = urlParams.get('uuid');
    const btnText = urlParams.get('btnText');

    const params = new URLSearchParams({
        ul: ul,
        li: li,
        tipo: tipo,
        operacao: operacaoUUID,
        uuid: uuid,
        btnText: btnText,
    });

    //carregar API's Externas
    const consultaUF = async () => {
        let uf = await VerificadoresAPI.uf('');
        setUfs(uf);
    };
    useEffect(() => {
        if (!token) {
            return navigate('/Auth', { replace: true });
        }

        consultaUF();

        if (uuid && uuid !== 'null') {
            CRUDsAPI.municipio
                .consulta(uuid)
                .then((response) => {
                    setDados(response.data);
                })
                .catch((error) => {
                    console.error(error);
                    setFlashMessage(error.response.data.message, error.response.data.type);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, uuid]);

    async function managerDados(dados) {
        let urlNavigate = pathname;

        try {
            let response;

            const formData = new FormData();

            const municipioFormData = Object.keys(dados).forEach((key) => {
                if (key === 'bandeira') {
                    for (let i = 0; i < dados[key]?.length; i++) {
                        formData.append(`bandeira`, dados[key][i]);
                    }
                } else {
                    formData.append(key, dados[key]);
                }
            });

            !municipioFormData && formData.append('bandeira', municipioFormData);

            if (uuid && uuid !== 'null') {
                response = await CRUDsAPI.municipio.editarComFormData(formData);
            } else {
                response = await CRUDsAPI.municipio.cadastrarComFormData(formData);

                if (response.status === 202) {
                    setDados(response.data);
                    response.data.message = 'Registro em duplicidade!';
                    response.data.type = 'warning';
                    urlNavigate = pathname + '/CreateOrEdit';
                    params.set('uuid', response.data.uuid);
                    params.set('btnText', 'Atualizar');
                }
            }

            setFlashMessage(response.data.message, response.data.type);

            setTimeout(() => {
                navigate(urlNavigate, params);
            }, parametro.msgTempo * 1000);
        } catch (error) {
            console.error(error);
            setFlashMessage(error.response.data.message, error.response.data.type);
        }
    }

    return (
        <section className={`${styles.form_container} ${styles[parametro.tema]}`}>
            <Form
                token={token}
                dados={dados}
                setDados={setDados}
                empresaId={empresaId}
                empresaIds={empresaIds}
                parametro={parametro}
                handleSubmit={managerDados}
                btnText={btnText}
                ufs={ufs}
                caminhoVoltar={pathname}
            />
        </section>
    );
};
export default CreateOrEdit;
